import { render, staticRenderFns } from "./WhySwitch.vue?vue&type=template&id=e171443e&scoped=true&"
import script from "./WhySwitch.vue?vue&type=script&lang=ts&"
export * from "./WhySwitch.vue?vue&type=script&lang=ts&"
import style0 from "./WhySwitch.vue?vue&type=style&index=0&id=e171443e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e171443e",
  null
  
)

export default component.exports